// Dimensions API compatibility
const Dimensions = {
  get: (dim) => {
    if (dim === 'window') {
      return {
        width: window.innerWidth,
        height: window.innerHeight,
        scale: window.devicePixelRatio || 1,
        fontScale: 1
      };
    }
    if (dim === 'screen') {
      return {
        width: window.screen.width,
        height: window.screen.height,
        scale: window.devicePixelRatio || 1,
        fontScale: 1
      };
    }
    return { width: 0, height: 0, scale: 1, fontScale: 1 };
  },
  
  addEventListener: (type, handler) => {
    if (type === 'change') {
      window.addEventListener('resize', () => {
        handler({
          window: Dimensions.get('window'),
          screen: Dimensions.get('screen')
        });
      });
    }
  },
  
  removeEventListener: (type, handler) => {
    if (type === 'change') {
      window.removeEventListener('resize', handler);
    }
  }
};

export default Dimensions;